import React from "react";

const NotFound = () => {
  return (
    <>
      <div className="not-found">
        404 (Not Found) <br></br>The page you are looking for does not exist.{" "}
        <br></br>
        Please check the URL then try again.
      </div>
    </>
  );
};

export default NotFound;
